#import "../CorporateWorkgroupsFields.graphql"
query CorporateWorkgroups(
  $orderBy: [CorporateWorkgroupsOrderBy!]
  $first: Int
  $after: Cursor
) {
  corporateWorkgroups(first: $first, orderBy: $orderBy, after: $after) {
    totalCount
    nodes {
      ...CorporateWorkgroupsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
